// hey its just like redux
module.exports.state = {};
